import React, { useContext, useEffect, useState } from "react";
import { Context } from "../App";
import { Backdrop, Box, Button, CircularProgress, IconButton, Stack, TextField, Typography } from "@mui/material";
import Header from "../Components/Header";
import { API } from "../conf";
import CompteSearch from "./autocomplet-search";
import { Delete } from "@mui/icons-material";
import DCLine from "./dc-ligne";

export default function CaisseRecette(props) {
    const agent = JSON.parse(sessionStorage.getItem('user'))
    const {updateConnect} = useContext(Context)
    const [load, setLoad] = useState(true)
    const [donators, setDonators] = useState([])
    const [eglises, setEglises] = useState([])
    const [fedcomptes, setFedcomptes] = useState([])
    const [comptes, setComptes] = useState([])
    const [debits, setDebits] = useState([{compte:'', label:'', amount:0}])
    const [credits, setCredits] = useState([{compte:'', label:'', amount:0}])

    const [client, setClient] = useState('')

    function handleSubmit(event) {
        event.preventDefault()
        const data = event.currentTarget()
        console.log(data);
        
    }

    function onchange_client(e) {
        setClient(e.target.value)
    }

    function get_donnateurs() { return new Promise((resolve, reject) => {
        fetch(API.concat('/donateurs'), {method: 'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    resolve(json)
                }
            }
        })
    })}

    function get_eglises() { return new Promise((resolve, reject) => {
        fetch(API.concat('/eglises'), {method: 'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    resolve(json)
                }
            }
        })
    })}

    function get_comptes_federals() { return new Promise((resolve, reject) => {
        fetch(API.concat(`/comptes/eglises/${agent.organisation}`), {method: 'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    resolve(json)
                }
            }
        })  
    })}

    useEffect(()=>{
        async function init_data() {
            setDonators(await get_donnateurs())
            setEglises(await get_eglises())
            setFedcomptes(await get_comptes_federals())
            setLoad(false)
        }

        init_data()
    }, [])

    return(
        <Box display='flex' flex={1} flexDirection='column'>
            <Header/>
            <Typography variant="h4" align="center" marginBlock={2}>Caisse</Typography>
            <Box component='form' onSubmit={handleSubmit} paddingInline={2} display='flex' flexDirection='column'>
                <Stack direction='column' spacing={2} padding={2} sx={{backgroundColor:'rgba(0,120,255,0.2)', border: '1px solid rgb(0,120,255)'}}>
                    <Typography variant="h5" align="center" color={'rgb(0,120,255)'}>Débit</Typography>
                    {debits.map((debit, index)=>
                        <DCLine key={index} comptes={fedcomptes} default={fedcomptes.find(cpt=>cpt.type==='petite-caisse')}
                        setCompte={(cpt)=>setDebits(old=>{old[index].compte=cpt._id; return[...old]})} 
                        line={debit} setLabel={label=>setDebits(old=>{old[index].label=label; return[...old]})} 
                        setMontant={amount => setDebits(old=>{old[index].amount=amount; return[...old]})} 
                        can_del={debits.length>1} del={()=>setDebits(old=>old.toSpliced(index,1))} />)
                    }
                    <Button variant="contained"
                    onClick={()=>setDebits(old=>[...old, {compte:'', label:'', amount:0}])}
                    style={{alignSelf:'center', backgroundColor:'white', color:'rgb(0,120,255)'}} >ajouter une ligne</Button>
                </Stack>

                <Stack direction='column' spacing={2} padding={2}>
                    <Typography variant="h5" align="center" color={'rgb(0,120,255)'}>Crédit</Typography>
                    {credits.map((credit, index)=>
                        <DCLine key={index} comptes={comptes} setCompte={(cpt)=>setCredits(old=>{old[index].compte=cpt._id; return[...old]})} 
                        line={credit} setLabel={label=>setCredits(old=>{old[index].label=label; return[...old]})} 
                        setMontant={amount => setCredits(old=>{old[index].amount=amount; return[...old]})} can_del={credits.length>1}
                        del={()=>setCredits(old=>old.toSpliced(index,1))} />)
                    }
                    <Button variant="contained"
                    onClick={()=>setCredits(old=>[...old, {compte:'', label:'', amount:0}])}
                    style={{alignSelf:'center', backgroundColor:'rgb(0,120,255)'}} >ajouter une ligne</Button>
                </Stack>

                <Button variant="contained" type="submit" style={{alignSelf:'end'}} 
                disabled={!debits.some(cd=>cd.amount>0)||parseFloat(debits.reduce((tt,cd)=>tt+cd.amount,0))!==parseFloat(credits.reduce((tt,cd)=>tt+cd.amount,0))||debits.some(cd=>cd.amount>0&&cd.compte==='')||credits.some(cd=>cd.amount>0&&cd.compte==='')}>valider</Button>
                
            </Box>
            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}